import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import "./Game.css";

interface GameProps {
  game: { [key: string]: unknown };
  book: string;
  showActive: boolean;
  rules:
    | Array<Record<string, unknown>>
    | Record<string, Record<string, unknown>>;
}

export default function Game({ game, book, showActive, rules }: GameProps) {
  const navigate = useNavigate();
  // const [showRules, setShowRules] = useState(false);
  const [currentRuleIndex, setCurrentRuleIndex] = useState(0);

  const hasBook =
    game["odds"] &&
    typeof game["odds"] === "object" &&
    book in (game["odds"] as Record<string, unknown>);

  const cleanOdds = (
    target_key: string,
    withPlus: boolean,
    withDecimal: boolean,
    prefix: string = "",
  ) => {
    if (
      !hasBook ||
      game === null ||
      game["odds"] === null ||
      !(game["odds"] as Record<string, unknown>)[book] ||
      !(
        (game["odds"] as Record<string, unknown>)[book] as Record<
          string,
          unknown
        >
      )[target_key]
    ) {
      return "-";
    }
    const base_str: string = String(
      (
        (game["odds"] as Record<string, unknown>)[book] as Record<
          string,
          unknown
        >
      )[target_key],
    );
    if (base_str === null) {
      return "-";
    }
    let cleanStr = "";
    if (withPlus && !base_str.startsWith("-")) {
      cleanStr = "+";
    }
    cleanStr = cleanStr + base_str;
    if (withDecimal && !base_str.includes(".")) {
      cleanStr = cleanStr + ".0";
    }

    cleanStr = prefix + cleanStr;

    return cleanStr;
  };

  const GoToGameDetails = () => {
    navigate(`/game/${game["id"]}`);
  };

  const GoToGameProps = () => {
    navigate(`/game/${game["id"]}/props`);
  };

  const stateId = localStorage.getItem("state_id");
  const subscriptionName = (
    localStorage.getItem("subscription_name") || ""
  ).toLowerCase();
  const isPro =
    stateId === "7" ||
    stateId === "8" ||
    subscriptionName.includes("pro") ||
    subscriptionName.includes("premium");

  const date = new Date(game["start_time"] as string);
  const localTime = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  const localDate = date.toLocaleString("en-US", {
    day: "numeric",
    month: "short",
  });

  return (
    <div className="game-container border_radius">
      <div
        className={`background_3  ${Array.isArray(rules) && rules.length > 0 ? " rule_hit" : "upcoming_border"} ${showActive ? " game-clickable" : ""}`}
        style={{
          cursor: "default",
          maxWidth: 600,
          margin: "0 auto",
          // borderColor: "#FF0000",
          // borderWidth: 2,
          // borderStyle: "solid",
          // borderRadius: 20,
        }}
      >
        <div className="game-row">
          <p
            className="font_family_base game-sport-text"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <span
              style={{
                fontSize: 20,
                cursor: showActive ? "pointer" : "default",
                display: "flex",
                alignItems: "center",
                marginTop: -5,
              }}
              onClick={GoToGameDetails}
            >
              📊
            </span>
            {isPro && (
              <span
                style={{
                  fontSize: 20,
                  cursor: showActive ? "pointer" : "default",
                  display: "flex",
                  alignItems: "center",
                  marginTop: -5,
                }}
                onClick={GoToGameProps}
              >
                🗝️
              </span>
            )}
          </p>
          <p
            className="font_family_base game-sport-text"
            style={{ display: "flex", alignItems: "center" }}
          >
            {game["sport"] as string}
          </p>
          <div
            style={{
              width: 120,
              minWidth: 120,
              maxWidth: 120,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {showActive ? (
              <p className="font_family_base game-score-text">
                {(game["game_status"] as Record<string, string> | null)?.[
                  "short"
                ] !== "F" &&
                  ((game["game_status"] as Record<string, string> | null)?.[
                    "timer"
                  ] ??
                    "")}
                {"\u00A0\u00A0\u00A0"}
                {(game["game_status"] as Record<string, string> | null)?.[
                  "period_display"
                ] ?? ""}
              </p>
            ) : (
              <p className="font_family_base game-time-text"></p>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flex: 1,
              alignSelf: "center",
            }}
          >
            {(() => {
              const isSoccer = game["sport_id"] === 7 || game["sport_id"] === 8;
              return isSoccer ? (
                <>
                  <div className="game-header-text-div">
                    <p className="font_family_base game-header-text">Home</p>
                  </div>
                  <div className="game-header-text-div">
                    <p className="font_family_base game-header-text">Draw</p>
                  </div>
                  <div className="game-header-text-div">
                    <p className="font_family_base game-header-text">Away</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="game-header-text-div">
                    <p className="font_family_base game-header-text">Spread</p>
                  </div>
                  <div className="game-header-text-div">
                    <p className="font_family_base game-header-text">Total</p>
                  </div>
                  <div className="game-header-text-div">
                    <p className="font_family_base game-header-text">
                      Moneyline
                    </p>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
        <div>
          {/* {showRules && Array.isArray(rules) && rules.length > 0 && ( */}
          {Array.isArray(rules) && rules.length > 0 && (
            <div
              className="font_family_base center_me header-border header_border_color"
              style={{
                fontSize: 12,
                color: "#ccc",
                paddingBottom: 4,
                marginBottom: 5,
                flexDirection: "column",
              }}
            >
              {(() => {
                const rulesArray = rules as Array<Record<string, unknown>>;
                const currentRule = rulesArray[currentRuleIndex];

                return (
                  <div style={{ width: "100%", position: "relative" }}>
                    <div style={{ marginBottom: 10, textAlign: "center" }}>
                      {String(currentRule["title"])}
                    </div>
                    <div
                      style={{ whiteSpace: "pre-line" }}
                      dangerouslySetInnerHTML={{
                        __html: String(currentRule["details"]),
                      }}
                    />

                    {rulesArray.length > 1 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: 10,
                        }}
                      >
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentRuleIndex((prev) =>
                              prev > 0 ? prev - 1 : rulesArray.length - 1,
                            );
                          }}
                          style={{
                            background: "transparent",
                            border: "1px solid #ccc",
                            color: "#ccc",
                            cursor: "pointer",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            fontSize: "16px",
                          }}
                        >
                          ←
                        </button>
                        <span style={{ fontSize: 10, color: "#999" }}>
                          {currentRuleIndex + 1} / {rulesArray.length}
                        </span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentRuleIndex((prev) =>
                              prev < rulesArray.length - 1 ? prev + 1 : 0,
                            );
                          }}
                          style={{
                            background: "transparent",
                            border: "1px solid #ccc",
                            color: "#ccc",
                            cursor: "pointer",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            fontSize: "16px",
                          }}
                        >
                          →
                        </button>
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          )}
        </div>

        <div
          className="game-row"
          style={{ alignItems: "center", marginBottom: 4 }}
        >
          <p
            className="font_family_base game-team-text"
            style={{ fontSize: 16, textAlign: "left" }}
          >
            {(() => {
              const isSoccer = game["sport_id"] === 7 || game["sport_id"] === 8;
              return isSoccer ? (
                <>{game["home_team"] as string}</>
              ) : (
                <>{game["away_team"] as string}</>
              );
            })()}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flex: 1,
              marginLeft: 10,
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 50,
                minWidth: 50,
                maxWidth: 50,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {showActive ? (
                <p className="font_family_base game-score-text">
                  {(() => {
                    const isSoccer =
                      game["sport_id"] === 7 || game["sport_id"] === 8;
                    return isSoccer ? (
                      <>{game["home_score"] as string}</>
                    ) : (
                      <>{game["away_score"] as string}</>
                    );
                  })()}
                </p>
              ) : (
                <p className="font_family_base game-time-text">{localTime}</p>
              )}
            </div>
            {(() => {
              const isSoccer = game["sport_id"] === 7 || game["sport_id"] === 8;
              return isSoccer ? (
                <>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content-centered">
                      <p
                        className="font_family_base game-odds-text"
                        style={{ marginTop: 6 }}
                      >
                        {cleanOdds("home_outcome_price", true, false)}
                      </p>
                    </div>
                  </div>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content-centered">
                      <p
                        className="font_family_base game-odds-text"
                        style={{ marginTop: 6 }}
                      >
                        {cleanOdds("draw_outcome_price", true, false)}
                      </p>
                    </div>
                  </div>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content-centered">
                      <p
                        className="font_family_base game-odds-text"
                        style={{ marginTop: 6 }}
                      >
                        {cleanOdds("away_outcome_price", true, false)}
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("away_spread_point", true, true)}
                      </p>
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("away_spread_price", true, false)}
                      </p>
                    </div>
                  </div>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("over_total_point", false, true, "O ")}
                      </p>
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("over_total_price", true, false)}
                      </p>
                    </div>
                  </div>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content-centered">
                      <p
                        className="font_family_base game-odds-text"
                        style={{ marginTop: 6 }}
                      >
                        {cleanOdds("away_outcome_price", true, false)}
                      </p>
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </div>

        <div
          className="game-row"
          style={{ alignItems: "center", marginBottom: 4 }}
        >
          <p
            className="font_family_base game-team-text"
            style={{ fontSize: 16, textAlign: "left" }}
          >
            {(() => {
              const isSoccer = game["sport_id"] === 7 || game["sport_id"] === 8;
              return isSoccer ? (
                <>{game["away_team"] as string}</>
              ) : (
                <>{game["home_team"] as string}</>
              );
            })()}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flex: 1,
              marginLeft: 10,
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 50,
                minWidth: 50,
                maxWidth: 50,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {showActive ? (
                <p className="font_family_base game-score-text">
                  {(() => {
                    const isSoccer =
                      game["sport_id"] === 7 || game["sport_id"] === 8;
                    return isSoccer ? (
                      <>{game["away_score"] as string}</>
                    ) : (
                      <>{game["home_score"] as string}</>
                    );
                  })()}
                </p>
              ) : (
                <p className="font_family_base game-time-text">{localDate}</p>
              )}
            </div>
            {(() => {
              const isSoccer = game["sport_id"] === 7 || game["sport_id"] === 8;
              return isSoccer ? (
                <>
                  <div className="game-odds-box  border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text"></p>
                    </div>
                  </div>
                  <div className="game-odds-box  border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text"></p>
                    </div>
                  </div>
                  <div className="game-odds-box  border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text"></p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("home_spread_point", true, true)}
                      </p>
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("home_spread_price", true, false)}
                      </p>
                    </div>
                  </div>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content">
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("under_total_point", false, true, "U ")}
                      </p>
                      <p className="font_family_base game-odds-text">
                        {cleanOdds("under_total_price", true, false)}
                      </p>
                    </div>
                  </div>
                  <div className="game-odds-box background_1 border_radius_small">
                    <div className="game-odds-content-centered">
                      <p
                        className="font_family_base game-odds-text"
                        style={{ marginTop: 6 }}
                      >
                        {cleanOdds("home_outcome_price", true, false)}
                      </p>
                    </div>
                  </div>
                </>
              );
            })()}

            {/* <div className="game-odds-box background_1 border_radius_small">
              <div className="game-odds-content">
                <p className="font_family_base game-odds-text">
                  {cleanOdds("home_spread_point", true, true)}
                </p>
                <p className="font_family_base game-odds-text">
                  {cleanOdds("home_spread_price", true, false)}
                </p>
              </div>
            </div>
            <div className="game-odds-box background_1 border_radius_small">
              <div className="game-odds-content">
                <p className="font_family_base game-odds-text">
                  {cleanOdds("under_total_point", false, true, "U ")}
                </p>
                <p className="font_family_base game-odds-text">
                  {cleanOdds("under_total_price", true, false)}
                </p>
              </div>
            </div>
            <div className="game-odds-box background_1 border_radius_small">
              <div className="game-odds-content-centered">
                <p
                  className="font_family_base game-odds-text"
                  style={{ marginTop: 6 }}
                >
                  {cleanOdds("home_outcome_price", true, false)}
                </p>
              </div>
            </div> */}
          </div>
        </div>

        {/* <div className="game-row" style={{ alignItems: "center" }}>
          <div className="game-row-98 background_3 border_radius_small">
            <div className="game-team-box">
              <p className="game-team-text">{game["home_team"] as string}</p>
            </div>
            <div className="game-score-box">
              {showActive ? (
                <p className="game-score-text">
                  {game["home_score"] as string}
                </p>
              ) : (
                <p className="game-time-text">{localDate}</p>
              )}
            </div>
          </div>
          <div className="game-odds-spacer" />
          <div className="game-row">
            <div className="game-odds-box background_2 border_radius_small">
              <div className="game-odds-content">
                <p className="game-odds-text">
                  {cleanOdds("home_spread_point", true, true)}
                </p>
                <p className="game-odds-text">
                  {cleanOdds("home_spread_price", true, false)}
                </p>
              </div>
            </div>
            <div className="game-odds-box background_2 border_radius_small">
              <div className="game-odds-content">
                <p className="game-odds-text">
                  {cleanOdds("under_total_point", false, true, "U ")}
                </p>
                <p className="game-odds-text">
                  {cleanOdds("under_total_price", true, false)}
                </p>
              </div>
            </div>
            <div className="game-odds-box background_2 border_radius_small">
              <div className="game-odds-content-centered">
                <p className="game-odds-text">
                  {cleanOdds("home_outcome_price", true, false)}
                </p>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="game-row">
          <div className="game-col-half">
            <div className="game-row">
              <div className="game-col-twothirds">
                {showActive && <p className="game-footer-text">Active Rule</p>}
              </div>
              <div className="game-col-third"></div>
            </div>
          </div>
          <div className="game-col-half">
            <div className="game-row">
              <div className="game-col-third">
                <p className="game-footer-text"></p>
              </div>
              <div className="game-col-third">
                <p className="game-footer-text"></p>
              </div>
              <div className="game-col-third">
                <p className="game-footer-text"></p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
